import { Chip } from "@mui/material";

import { SelectedChipIcon, UnSelectedChipIcon } from "../../assets/icons/MUI/components";

const MultiChipCheck = ({
  label,
  isSelected,
  handleOnClick,
}: {
  label: string;
  isSelected: boolean;
  handleOnClick: () => void;
}) => {
  return (
    <Chip
      label={label}
      size="small"
      icon={isSelected ? <SelectedChipIcon /> : <UnSelectedChipIcon />}
      onClick={handleOnClick}
      sx={chipStyle(isSelected)}
    />
  );
};

export default MultiChipCheck;

const chipStyle = (isSelected: boolean) => ({
  textAlign: "center",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "20px",
  textTransform: "capitalize",
  cursor: "pointer",
  transition: "all 0.2s ease",
  border: isSelected ? "var(--Brand-600, #008B07) !important" : "1px solid var(--Gray-200, #E4E7EC) !important",
  color: isSelected ? " var(--White, #FFF) !important" : "1px solid var(--Gray-200, #E4E7EC) !important",
  padding: "4px 12px 4px 10px",
  gap: "4px",
  borderRadius: "16px",
  background: isSelected ? "var(--Brand-600, #008B07) !important" : "var(--Gray-50, #F9FAFB) !important",
  height: "fit-content",
  "&:hover": {
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  "& .MuiChip-label": {
    padding: 0,
  },
  "& .MuiChip-icon": {
    margin: 0,
  },
});
